import React from 'react';
import { Box, ListItemButton, Typography } from '@mui/material';
import { isDarkWidgetColor } from '../WidgetConfig';

const TimeSlotButton = ({
  time,
  selectedTime,
  onSelectTime,
  currentColor,
  isAvailable = true,
  isFullyBooked = false,
}) => {
  const selectedTextColor = currentColor.onPrimary ?? currentColor.mainbg ?? '#fff';
  const isDark = isDarkWidgetColor(currentColor);
  const slotBorder = isDark ? 'rgba(255, 255, 255, 0.35)' : '#d7d7d7';
  const unselectedText = isDark ? currentColor.text ?? '#ffffff' : 'inherit';

  const buttonStyles = isFullyBooked
    ? {
        border: `1px solid ${slotBorder}`,
        borderRadius: '8px',
        bgcolor: currentColor.primary,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: selectedTextColor,
        justifyContent: 'center',
        '&.Mui-selected, &:hover, &:focus': {
          border: '1px solid',
          borderColor: currentColor.primary,
          bgcolor: currentColor.primary,
          color: currentColor.mainbg,
        },
      }
    : isAvailable
    ? {
        border: `1px solid ${slotBorder}`,
        borderRadius: '8px',
        '&.Mui-selected, &:hover, &.Mui-focusVisible': {
          border: '1px solid',
          borderColor: currentColor.primary,
          bgcolor: currentColor.primary,
          color: currentColor.mainbg,
        },
      }
    : {
        border: `1px solid ${slotBorder}`,
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
          borderColor: currentColor.primary,
        },
        '&.Mui-selected': {
          borderColor: currentColor.primary,
          backgroundColor: currentColor.primary,
          color: currentColor.mainbg,
          '&:hover': {
            backgroundColor: currentColor.primary,
            color: currentColor.mainbg,
            borderColor: currentColor.primary,
          },
        },
      };

  return (
    <Box>
      <ListItemButton
        disabled={!isAvailable && !isFullyBooked}
        onClick={() => onSelectTime(time?.Time, time.ReservationPoint, time?.Deposit)}
        selected={selectedTime === time?.Time}
        sx={{
          ...buttonStyles,
          minHeight: 44,
          justifyContent: 'center',
          borderRadius: '8px',
          bgcolor:
            selectedTime === time?.Time ? currentColor.primary : 'background.paper',
          color:
            selectedTime === time?.Time ? selectedTextColor : unselectedText,
        }}
      >
        <Typography
          sx={{
            fontSize: isFullyBooked ? '10px' : '12px',
            whiteSpace: 'nowrap',
          }}
        >
          {time?.Time}
        </Typography>
        {isFullyBooked && (
          <>
            <Typography
              sx={{
                fontSize: '8px',
                whiteSpace: 'nowrap',
                mt: -1,
              }}
            >
              Reserved
            </Typography>
            <Typography
              sx={{
                fontSize: '8px',
                whiteSpace: 'nowrap',
                mt: -1,
              }}
            >
              Join Waitlist
            </Typography>
          </>
        )}
      </ListItemButton>
      {time?.ReservationPoint && (
        <Typography
          sx={{
            textAlign: 'center',
            fontSize: '10px',
            color: 'primary.main',
            fontWeight: 700,
          }}
        >
          +{time?.ReservationPoint?.Value}pts
        </Typography>
      )}
    </Box>
  );
};

export default TimeSlotButton;
